// extracted by mini-css-extract-plugin
export default {"container":"hK-z","dimension":"iK-z","dimensionLabels":"jK-z"};